import { Skeleton } from "@mui/material";
import Box from "@mui/material/Box";

const FakeCreditForm = () => {
  return (
    <>
      <form>
        <Skeleton variant="text" width={300} className="mb-3" />

        <Box className="row">
          <Box className="col-sm-4 mb-3">
            <Box className="form-floating">
              <Box className="form-floating">
                <Skeleton variant="rectangular" className="form-control" />
              </Box>
            </Box>
          </Box>
          <Box className="col-sm-4 mb-3">
            <Box className="form-floating">
              <Box className="form-floating">
                <Skeleton variant="rectangular" className="form-control" />
              </Box>
            </Box>
          </Box>
          <Box className="col-sm-4 mb-3">
            <Box className="form-floating">
              <Box className="form-floating">
                <Skeleton variant="rectangular" className="form-control" />
              </Box>
            </Box>
          </Box>
          <Box className="col-sm-4 mb-3">
            <Box className="form-floating">
              <Box className="form-floating">
                <Skeleton variant="rectangular" className="form-control" />
              </Box>
            </Box>
          </Box>
          <Box className="col-sm-4 mb-3">
            <Box className="form-floating">
              <Box className="form-floating">
                <Skeleton variant="rectangular" className="form-control" />
              </Box>
            </Box>
          </Box>
        </Box>

        <hr />

        <Skeleton variant="text" width={300} className="mb-3" />

        <Box className="row">
          <Box className="col-sm-4 mb-3">
            <Box className="form-floating">
              <Box className="form-floating">
                <Skeleton variant="rectangular" className="form-control" />
              </Box>
            </Box>
          </Box>
          <Box className="col-sm-4 mb-3">
            <Box className="form-floating">
              <Box className="form-floating">
                <Skeleton variant="rectangular" className="form-control" />
              </Box>
            </Box>
          </Box>
          <Box className="col-sm-4 mb-3">
            <Box className="form-floating">
              <Box className="form-floating">
                <Skeleton variant="rectangular" className="form-control" />
              </Box>
            </Box>
          </Box>
        </Box>

        <hr />

        <Skeleton variant="text" width={300} className="mb-3" />

        <Box className="row">
          <Box className="col-sm-4 mb-3">
            <Box className="form-floating">
              <Box className="form-floating">
                <Skeleton variant="rectangular" className="form-control" />
              </Box>
            </Box>
          </Box>
          <Box className="col-sm-4 mb-3">
            <Box className="form-floating">
              <Box className="form-floating">
                <Skeleton variant="rectangular" className="form-control" />
              </Box>
            </Box>
          </Box>
          <Box className="col-sm-4 mb-3">
            <Box className="form-floating">
              <Box className="form-floating">
                <Skeleton variant="rectangular" className="form-control" />
              </Box>
            </Box>
          </Box>
          <Box className="col-sm-4 mb-3">
            <Box className="form-floating">
              <Box className="form-floating">
                <Skeleton variant="rectangular" className="form-control" />
              </Box>
            </Box>
          </Box>
          <Box className="col-sm-4 mb-3">
            <Box className="form-floating">
              <Box className="form-floating">
                <Skeleton variant="rectangular" className="form-control" />
              </Box>
            </Box>
          </Box>
          <Box className="col-sm-4 mb-3">
            <Box className="form-floating">
              <Box className="form-floating">
                <Skeleton variant="rectangular" className="form-control" />
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          className="text-center"
        >
          <Skeleton
            variant="rectangular"
            className="form-control mt-3"
            width={300}
            height={40}
          />
        </Box>
      </form>
    </>
  );
};

export default FakeCreditForm;
